export const environment = {
  production: false,
  dev: false,
  example: 'This is an example ENV string for PROD',
  apiUrl: '/api/v1',
  cloudSearchEndpoint: 'https://easylot.link',
  cloudSearchRegion: 'eu-central-1',
  imageStorageUrl: 'https://images.easylot.link',
  documentsStorageUrl: 'https://images.easylot.link/documents',
  newsletterScriptUrl:
    'https://r3.minicrm.hu/api/loader.js?43169-1kzj8ofb4u0wkp4ciojv',
  featureToggles: {
    disableMarketingDataLogoUpload: false,
  },
  analyticsTrackingCode: '',
  optimonkAccountId: '',
  ghostApiUrl: '/ghost/api',
  blogFeatureEnabled: false,
  supportEmail: 'schmidt.janos+support@easylot.hu',
  environmentName: 'qa',
};
